import Image from 'next/future/image';
import Link from 'next/link';
import sparks from '@/public/images/homepage/deals/sparks.png';
import controller from '@/public/images/homepage/deals/controller.png';
import smartwatch from '@/public/images/homepage/deals/smartwatch.png';
import smartphone from '@/public/images/homepage/deals/smartphone.png';
import mixer from '@/public/images/homepage/deals/mixer.png';
import save from '@/public/images/homepage/deals/save.svg';
import daily from '@/public/images/homepage/deals/daily.svg';

const Default = ({
  title,
  countdown,
}: {
  title: string;
  countdown: string;
}) => (
  <div className="relative rounded-t-2xl bg-gray-700 lg:w-1/3 lg:rounded-l-2xl lg:rounded-tr-none">
    <div className="absolute inset-0 h-full w-full">
      <Image
        src={sparks}
        className="h-full w-full object-contain"
        alt="Sparks"
      />
    </div>

    <div className="absolute bottom-0 h-[150px] xl:h-[175px]">
      <Image
        src={smartphone}
        className="h-full w-auto rounded-bl-2xl object-contain"
        alt="Sparks"
        quality={100}
      />
    </div>
    <div className="absolute top-0 h-[150px] xl:h-[175px]">
      <Image
        src={mixer}
        className="h-full w-auto rounded-tl-2xl object-contain"
        alt="Mixer"
        quality={100}
      />
    </div>
    <div className="absolute right-0 top-[-25px] h-[150px] xl:top-[-30px] xl:h-[175px]">
      <Image
        src={controller}
        className="h-full w-auto object-contain"
        alt="Controller"
        quality={100}
      />
    </div>
    <div className="absolute bottom-0 right-0 h-[125px]">
      <Image
        src={smartwatch}
        className="h-full w-auto object-contain"
        alt="Smartwatch"
        quality={100}
      />
    </div>
    {/* Content  */}
    <div className="relative flex h-full w-full flex-col items-center justify-center py-8 text-white">
      <div className="mb-5 h-8">
        <Image
          src={save}
          className="h-full w-auto object-contain"
          alt="Controller"
          quality={100}
        />
      </div>
      <h3 className="text-base md:text-lg">{title}</h3>
      <span className="text-2xl font-extrabold">{countdown}</span>
      <Link href="/collections/hot-deals">
        <button
          type="button"
          className="mt-5 h-8 rounded-md !bg-white px-3 text-xs font-extrabold text-gray-700"
        >
          Shop all Deals
        </button>
      </Link>
      <div className="mt-3 h-9">
        <Image
          src={daily}
          className="h-full w-auto object-contain"
          alt="Controller"
          quality={100}
        />
      </div>
    </div>
  </div>
);

export default Default;
